import { Environment, Type } from '@lendi/lala-react';

import { TEAM_VIEW_BASE_NAME } from '@funnels/constants';

import { getBrandSpecificBaseURL } from './brand';
import getViewType from './getViewType';

export default function getAppParams(env: string | undefined) {
  const isTeamView = getViewType() === Type.Team;
  let appEnv;
  let type;
  let basename: string;
  switch (env) {
    case 'staging':
      appEnv = Environment.Staging;
      break;
    case 'production':
      appEnv = Environment.Production;
      break;
    default:
      appEnv = Environment.Development;
  }

  if (isTeamView) {
    type = Type.Team;
    basename = TEAM_VIEW_BASE_NAME;
  } else {
    type = Type.Customer;
    basename = getBrandSpecificBaseURL();
  }

  return { appEnv, type, basename };
}
